interface CloudWithCircleAndPowerIconSVGProps {
  color: string;
  style: React.CSSProperties;
}

const CloudWithCircleAndPowerIconSVG = ({
  color,
  style,
}: CloudWithCircleAndPowerIconSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="50"
    viewBox="0 0 44 50"
    fill="none"
  >
    <g clipPath="url(#clip0_1753_13581)">
      <path
        d="M6.77784 27.5933C3.1109 25.932 0.568359 22.2449 0.568359 17.96C0.568359 12.1253 5.29891 7.39477 11.1336 7.39477C12.3795 7.39477 13.5748 7.6075 14.679 8.00255C16.006 3.69745 20.0274 0.567383 24.7782 0.567383C30.6129 0.567383 35.3435 5.29793 35.3435 11.1326C35.3435 11.9126 35.2523 12.6622 35.1004 13.3915C35.2017 13.3915 35.2928 13.3814 35.3941 13.3814C39.5777 13.3814 42.9711 16.7748 42.9711 20.9584C42.9711 24.6962 40.2665 27.7959 36.711 28.4138"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.2963 45.6133C24.2732 46.2717 23.0678 46.6566 21.7712 46.6566C20.4746 46.6566 19.2591 46.2717 18.2461 45.6133"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.0985 47.8623C25.5588 48.855 23.7355 49.4324 21.7602 49.4324C19.7951 49.4324 17.9616 48.855 16.4219 47.8623"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.1991 43.6689C22.7838 43.9323 22.2975 44.0944 21.7607 44.0944C21.2238 44.0944 20.7376 43.9424 20.3223 43.6689"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7578 35.7178V33.4893"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3492 34.543C19.8934 34.938 19.5996 35.5255 19.5996 36.1738C19.5996 37.3691 20.5619 38.3315 21.7572 38.3315C22.9525 38.3315 23.9148 37.3691 23.9148 36.1738C23.9148 35.5458 23.6413 34.9785 23.2058 34.5835"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6327 35.1096C29.3953 33.5092 30.4994 31.1996 30.4994 28.6267C30.4994 23.8049 26.5894 19.8848 21.7575 19.8848C16.9257 19.8848 13.0156 23.7948 13.0156 28.6267C13.0156 31.1996 14.1198 33.5092 15.8924 35.1096L18.7997 32.2227C17.7664 31.3718 17.108 30.0752 17.108 28.6267C17.108 26.0537 19.1947 23.967 21.7677 23.967C24.3406 23.967 26.4273 26.0537 26.4273 28.6267C26.4273 30.0651 25.7689 31.3515 24.7458 32.2126L27.6429 35.1096H27.6327Z"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7578 19.8945V21.5558"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3926 21.0703L18.2232 22.5087"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1914 24.2705L15.6399 25.1011"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0254 28.6367H14.6867"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.4992 28.6367H28.8379"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3333 24.2705L27.8848 25.1011"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.1353 21.0703L25.3047 22.5087"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.7685 37.6494C35.745 32.6729 35.745 24.6044 30.7686 19.6279C25.7921 14.6514 17.7236 14.6514 12.7471 19.6279C7.77057 24.6044 7.77057 32.6729 12.7471 37.6494C17.7236 42.6259 25.7921 42.6259 30.7685 37.6494Z"
        stroke={color}
        strokeWidth="1.13452"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1753_13581">
        <rect width="43.5271" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default CloudWithCircleAndPowerIconSVG;
